import { TStatusDatamanagement } from "../common";
import { DatamanageMent, ICenter, IuserProfile, typeTeam } from "../models/models-datamanagement";
export interface IDatamanagementService {
  getUserDetail: () => Promise<IuserProfile>;
  getDataManagementRuleBaseByname: (dataProfile: string) => Promise<any>;
  createCondition: (rulesCreate: any) => Promise<number>;
  getDraftDataManagementByid: (dataProfile: IuserProfile) => Promise<DatamanageMent>;
  updateConditionByid: (AssignUserNew: string, dataBody: any) => Promise<number>;
  updateConditionByseq: (seq: any, dataProfile: IuserProfile, status: string) => Promise<number>;
  getCountUnList: () => Promise<string>;
  setExecuteRuleBase: (userid: number) => Promise<any>;
  setSimulateRuleBase: (CleardistNew: any) => Promise<any>;
  getTeamAll: () => Promise<typeTeam[]>;
  clearDist: (dataProfile: IuserProfile) => Promise<typeTeam[]>;
  getTeamList: () => Promise<typeTeam[]>;
  assignConditions: (CleardistNew: any) => Promise<any>;
  getDataRulebase: () => Promise<any>;
  getUnlistList: (filter: any) => Promise<any>;
  getOaList: (data: any) => Promise<string>;
  getCenterList: () => Promise<ICenter>;
  getTeamByUser: (id: number) => Promise<any>;
  getUserAll: () => Promise<any>;
  getOabytoken: () => Promise<any>;
  deleteRuleBase: (distributionId: any, seq: any) => Promise<any>;
  // new
  getdataworklist: () => Promise<any>;
  getdatafloodstatus: () => Promise<any>;
  getdatariskscore: () => Promise<any>;
  getdatabillcode: () => Promise<any>;
  getdatacusttype: () => Promise<any>;
  getdatalasttermcode: () => Promise<any>;
  clearDataUnlist: (dataProfile: IuserProfile) => Promise<any>;
  getUserInGroupDatamanagement: () => Promise<[]>;
  simulateStatus: (dataProfile: IuserProfile) => Promise<TStatusDatamanagement>;
  executeStatus: (userid: number) => Promise<TStatusDatamanagement>;
  assignStatus: (userid?: number | string) => Promise<TStatusDatamanagement>;
  simulateAssign: (dataProfile: number) => Promise<any>;
  getUserBankByOrganize: () => Promise<any>;
  clearDataUnlistNouserZero: (UserId: number) => Promise<any>;

  Export: () => Promise<any>;
}
export const DatamanagementService = (serviceBackendApi: any): IDatamanagementService => ({
  getUserDetail: async () => {
    const result = await serviceBackendApi.get(`/debtor/userDetails`);
    return result.data.result;
  },
  getDataManagementRuleBaseByname: async (dataProfile) => {
    const result = await serviceBackendApi.get(`/rule-base/${dataProfile}`);
    return result.data.result;
  },
  getDataRulebase: async () => {
    const result = await serviceBackendApi.get(`/rule-base`);
    return result.data.result;
  },
  createCondition: async (rulesCreate: any) => {
    const databody = rulesCreate[0];
    const result = await serviceBackendApi.post("/rule-base", databody);

    return result.status;
  },
  updateConditionByid: async (AssignUserNew, dataBody) => {
    const result = await serviceBackendApi.put(`/rule-base/${AssignUserNew}`, dataBody[0]);
    return result.status || {};
  },
  getDraftDataManagementByid: async (dataProfile) => {
    let employeeIdNew = `User:${dataProfile.id}:AssignUser`;

    const result = await serviceBackendApi.get(`/rule-base/${employeeIdNew}`);
    return result.data.result;
  },
  updateConditionByseq: async (seq, dataProfile, status) => {
    const databody = {
      seq: seq,
      status: status,
    };
    let employeeIdNew = `User:${dataProfile.id}:AssignUser`;

    const result = await serviceBackendApi.put(`/rule-base/seq-status/${employeeIdNew}`, databody);
    return result.status;
  },
  getCountUnList: async () => {
    //apiBaseUrlDebt
    const result = await serviceBackendApi.get(`/search/countUnList`);

    return result?.data.result || {};
  },
  setExecuteRuleBase: async (CleardistNew: number) => {
    const dataBody = { userId: CleardistNew };
    const result = await serviceBackendApi.post(`/rule-base/execute`, dataBody);

    return result || {};
  },
  setSimulateRuleBase: async (dataProfile) => {
    const dataBody = { userId: dataProfile };
    const result = await serviceBackendApi.post(`/debt/simulate`, dataBody);

    return result.data.result;
  },

  getTeamAll: async () => {
    const result = await serviceBackendApi.get("/dist/all");
    return result.data.result;
  },
  clearDist: async (dataProfile) => {
    let employeeIdNew = `User:${dataProfile.id}:AssignUser`;
    const dataBody = { userId: employeeIdNew };
    const result = await serviceBackendApi.post(`/debtor/clearDist`, dataBody);
    return result.data.result;
  },
  getTeamList: async () => {
    const result = await serviceBackendApi.get("/dist/all");

    return result?.data.result || {};
  },
  assignConditions: async (dataProfile) => {
    const dataBody = {
      userId: dataProfile,
      assignType: "Manual",
    };
    const result = await serviceBackendApi.post("/debt/submit", dataBody);
    return result.data.result || {};
  },
  getUnlistList: async (filter: any) => {
    // serviceBackendDebt
    const result = await serviceBackendApi.post("/search/unList", filter);
    return result?.data.result || {};
  },
  getOaList: async (data: any) => {
    //serviceBackendDebt
    const result = await serviceBackendApi.post("/search/oa", {
      condition: {},
    });
    return result?.data.result || {};
  },
  getCenterList: async () => {
    //serviceBackendDebt
    const result = await serviceBackendApi.get("/search/centerBranch");
    return result?.data.result || {};
  },
  getTeamByUser: async (id) => {
    const data = {
      id: id,
    };
    const result = await serviceBackendApi.post("/user/teambyuser", data);
    return result?.data.result || {};
  },
  getUserAll: async () => {
    // serviceBackendDebt
    const data = {};
    const result = await serviceBackendApi.get("/debtor/getUserAll");
    return result?.data.result || {};
  },

  getOabytoken: async () => {
    // serviceBackendDebt
    const data = {};
    const result = await serviceBackendApi.get("/search/oaBytoken");
    return result?.data.result || {};
  },
  deleteRuleBase: async (distributionId, seq) => {
    const data = {
      seq: seq,
      distributionId: distributionId,
    };
    const result = await serviceBackendApi.post(`/debtor/rulebaseDelete`, data);
    return result?.data?.result || {};
  },
  Export: async () => {
    // serviceBackendDebt
    const result = await serviceBackendApi.post(`http://localhost:3001/search/csv`, { loanType: "OD" });
    return result || {};
  },
  getdataworklist: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/worklistDistinct`);
    return result.data.result;
  },
  getdatafloodstatus: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/floodDistinct`);
    return result.data.result;
  },
  getdatariskscore: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/riskDayDistinct`);
    return result.data.result;
  },
  getdatabillcode: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/billCodeDistinct`);
    return result.data.result;
  },
  getdatacusttype: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/custTypeDistinct`);
    return result.data.result;
  },
  getdatalasttermcode: async () => {
    //serviceBackend
    const result = await serviceBackendApi.get(`/import/data-master/lastTermCodeDistinct`);
    return result.data.result;
  },
  clearDataUnlist: async (dataProfile) => {
    //serviceBackend
    let employeeIdNew;
    if (dataProfile.level === "MANAGER" && dataProfile.type === "BANK") {
      employeeIdNew = 0;
    } else if (dataProfile.level === "SUPERVISOR" && dataProfile.type === "BANK") {
      employeeIdNew = 0;
    } else {
      employeeIdNew = `User:${dataProfile.id}:AssignUser`;
    }
    const dataBody = { userId: employeeIdNew };
    const result = await serviceBackendApi.post(`/debt/clearUnlist`, dataBody);
    return result?.data?.result;
  },
  getUserInGroupDatamanagement: async () => {
    // apiBaseUrlDebt
    const result = await serviceBackendApi.get(`/debtor/userList`);
    return result.data.result;
  },
  simulateStatus: async (dataProfile) => {
    const data = {
      userId: dataProfile.id,
    };
    const result = await serviceBackendApi.post(`/datamanagement/status/simulateStatus`, data);
    return result.data || {};
  },
  assignStatus: async (userid) => {
    const data = {
      userId: userid,
    };
    const result = await serviceBackendApi.post(`/datamanagement/status/assignStatus`, data);
    return result.data || {};
  },
  executeStatus: async (CleardistNew) => {
    const data = {
      userId: CleardistNew,
    };
    const result = await serviceBackendApi.post(`/datamanagement/status/executeStatus`, data);
    return result.data || {};
  },
  simulateAssign: async (dataProfile) => {
    // serviceBackendDebt
    const data = {
      userId: dataProfile,
    };
    const result = await serviceBackendApi.post(`/debt/simulateAssign`, data);
    return result?.data || {};
  },
  getUserBankByOrganize: async () => {
    const result = await serviceBackendApi.get("/bank/user/organize");
    return result?.data || {};
  },
  clearDataUnlistNouserZero: async (UserId) => {
    const dataBody = { userId: UserId };
    const result = await serviceBackendApi.post(`/debt/pullBackToUpper`, dataBody);
    return result?.data?.result;
  },
});
